module.exports = __webpack_public_path__ + "img/hutaomu7.e87d5eb2.jpg";